import Logo from "../../atoms/images/Logo";

const Header = () => {
  return (
    <div className="base-top flex">
      <div className="koica_logo">
        <img src="../../../../img/khcp/khcp_ko.png" style={{width: "162.3px", height: "auto"}} />
      </div>
      <div>
        {/* <Logo /> */}
        <img src="../../../../img/koica/SLI_LOGO.png" style={{width: "162.3px", height: "67.6px"}} />
        {/*<a className="login-btn">로그인</a>*/}
        {/*<a className="start-btn">시작하기</a>*/}
      </div>
    </div>
  );
};

export default Header;
